import { render, staticRenderFns } from "./LicitacaoFornecedorTermosCredenciamento.vue?vue&type=template&id=1f0ab15f"
import script from "./LicitacaoFornecedorTermosCredenciamento.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorTermosCredenciamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports